export default __webpack_public_path__ + "assets/images/topik-positive.d2d55c0e0977c065d508ccc0bb3ae78b.svg";